import styles from './ArticleCard.module.css';

export default function ArticleCard({ imgSrc, publisher, title, url }) {
    return (
        <div className={styles.articleCardContainer}>
            <div className={styles.articleCardHeader}>
                <img src={imgSrc} alt={publisher} className={styles.publisherImage} />
                <h3 className={styles.publisher}>{publisher}</h3>
            </div>
            <div className={styles.articleCardBody}>
                <h2 className={styles.articleTitle}>{title}</h2>
                <div className={styles.buttonContainer}>
                    <a href={url} target="_blank" rel="noopener noreferrer" className={styles.getStartedButton}>
                        Read Article
                    </a>
                </div>
            </div>
        </div>
    );
}